import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';

const LoadingScreen: React.FC = () => {
    const { theme } = useTheme();
    const isDarkMode = theme === 'dark';

    return (
        <div className={`min-h-screen flex items-center justify-center ${isDarkMode ? 'bg-gray-900' : 'bg-white'}`}>
            <div className="flex flex-col items-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
            </div>
        </div>
    );
};

export default LoadingScreen;
